// extracted by mini-css-extract-plugin
export var footer = "_o9-5";
export var fulfillmentInput = "_o9-0";
export var shipDateInput = "_o9-1";
export var shipmentModal = "_o9-2";
export var shipmentModalContent = "_o9-3";
export var tableContainer = "_o9-4";